import { render, staticRenderFns } from "./app-down.vue?vue&type=template&id=5a20f994&scoped=true"
import script from "./app-down.vue?vue&type=script&lang=js"
export * from "./app-down.vue?vue&type=script&lang=js"
import style0 from "./app-down.vue?vue&type=style&index=0&id=5a20f994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a20f994",
  null
  
)

export default component.exports